<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { reportedProduction } from "./cnmcPresentation";
import type { CnmcPlan } from "./cnmcTypes";

const props = defineProps<{ plan: CnmcPlan }>();
const { n } = useI18n();
const figures = computed(() =>
  [
    { label: "net_production", value: reportedProduction(props.plan) },
    { label: "domestic_volume", value: props.plan.domestic_go_count },
    { label: "export_volume", value: props.plan.export_go_count },
    {
      label: "unallocated_fraction",
      value: props.plan.inputs.production_sources.reduce(
        (sum, source) =>
          sum + Number(source.value) - Math.floor(Number(source.value)),
        0
      ),
    },
  ].filter(
    ({ label, value }) =>
      value !== 0 ||
      !["domestic_volume", "unallocated_fraction"].includes(label)
  )
);
</script>

<template>
  <dl class="cnmc-summary mb-0">
    <div v-for="figure in figures" :key="figure.label">
      <div class="border rounded-3 p-3 h-100">
        <dt class="small fw-normal text-body-secondary mb-2">
          {{ $t(`cnmc.${figure.label}`) }}
        </dt>
        <dd class="cnmc-quantity font-serif mb-0">
          {{ n(figure.value, { maximumFractionDigits: 3 }) }}
          <span class="small text-body-secondary">MWh</span>
        </dd>
      </div>
    </div>
  </dl>
</template>

<style scoped lang="scss">
.cnmc-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 145px), 1fr));
  gap: 12px;
}
.cnmc-quantity {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.cnmc-quantity span {
  font: 400 12px var(--phoenix-font-sans-serif);
}
</style>
